import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import darkTheme from "./src/theme";
import "typeface-rajdhani";
import "typeface-poppins";

export const wrapPageElement = ({ element }) => (
  <ThemeProvider theme={darkTheme}>
    <CssBaseline />
    {element}
  </ThemeProvider>
);
